import { type FC, memo } from 'react'

interface CheckboxProps {
    active: boolean
    onClick: () => void
    title?: string
}

export const Checkbox: FC<CheckboxProps> = memo(({ active, onClick, title }) => {
    return (
        <li>
            <label className='catalog__sort-checkbox'>
                <input
                    onClick={onClick}
                    checked={active}
                    type='checkbox'
                    name='matches'
                    value='yes'
                />
                <span className='catalog__sort-checkbox-icon'>
                    <svg
                        width='20'
                        height='20'
                        viewBox='0 0 13 10'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M2 4.25L5.75 8L11 2'
                            stroke='#EAF0FF'
                            strokeWidth='2'
                            strokeLinecap='square'
                        />
                    </svg>
                </span>
                <span className='catalog__sort-checkbox-text'>{title}</span>
            </label>
        </li>
    )
})
